import { useRequiredContext } from "@redotech/react-util/context";
import DataflowIcon from "@redotech/redo-icons/dataflow-03.svg";
import UserIcon from "@redotech/redo-icons/user-01.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import {
  SelectedShippingRateSetBy,
  SelectedShippingRateSetByInfo,
} from "@redotech/redo-model/fulfillments/selected-shipping-rate-set-by";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Tooltip as RedoTooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";

export const AutomationInfoIcon = memo(function AutomationInfoIcon({
  selectedShippingRateSetBy,
  selectedShippingRateSetByInfo,
}: {
  selectedShippingRateSetBy?: SelectedShippingRateSetBy | null;
  selectedShippingRateSetByInfo?: SelectedShippingRateSetByInfo | null;
}) {
  const team = useRequiredContext(TeamContext);

  if (!selectedShippingRateSetBy) {
    return null;
  }

  const selectedShippingRateAutomationName =
    selectedShippingRateSetByInfo?.selectedShippingRateAutomationName;
  const userId = selectedShippingRateSetByInfo?.selectedShippingRateUserId;
  const user = userId ? team.users.find((u) => u._id === userId)?.user : null;

  const userName =
    typeof user === "object" && user !== null
      ? `${user.firstName} ${user.lastName}`
      : null;

  let tooltipText = "";
  let icon = DataflowIcon;
  const iconColor = "brand"; // Same color as learning icon

  switch (selectedShippingRateSetBy) {
    case "user":
      tooltipText = userName
        ? `Shipping selected by ${userName}`
        : "Shipping selected by user";
      icon = UserIcon;
      break;
    case "learning":
      tooltipText = "Selected by Redo learning";
      icon = DataflowIcon;
      break;
    case "automations":
      tooltipText = selectedShippingRateAutomationName
        ? `Selected by automation: ${selectedShippingRateAutomationName}`
        : "Selected by automation";
      icon = DataflowIcon;
      break;
    case "default_cheapest":
      tooltipText = "Cheapest rate selected";
      icon = DataflowIcon;
      break;
    case "checkout_rate_purchased":
      tooltipText = "Rate selected at checkout";
      icon = DataflowIcon;
      break;
    default:
      tooltipText = `Selected by: ${selectedShippingRateSetBy}`;
      icon = DataflowIcon;
  }

  return (
    <RedoTooltip title={tooltipText}>
      <Flex flexDirection="column" justify="center">
        <RedoIcon color={iconColor} Icon={icon} />
      </Flex>
    </RedoTooltip>
  );
});
